import * as React from "react";
import * as S from "@styled";
import _ from "lodash";

export const DeployDialogFooter: React.FC<DeployDialogFooterProps> = (props) => {

    const handleDeployActivate = () => {
        props.handleDeploy(true, props.deploymentDescription);
    };

    const handleDeployWithoutActivate = () => {
        props.handleDeploy(false, props.deploymentDescription);
    };

    const buttonLabel = () => props.isSwitchVersion ? FRENDS.Localizations.Switch : FRENDS.Localizations.Deploy;

    const getSubprocessDeploymentFooter = () => {
        return (
            <S.ButtonGroup gap={35} $justifyContentEnd={true}>
                <S.Button variant={S.ButtonType.bordered} onClick={props.closeDeployDialog}>{FRENDS.Localizations.Cancel}</S.Button>
                <S.Button
                    disabled={props.deploymentDisabled}
                    onClick={handleDeployWithoutActivate}
                >
                    {buttonLabel()}
                </S.Button>
            </S.ButtonGroup>
        );
    };

    const getProcessDeploymentFooter = () => {
        return (
            <S.FormGroup style={{ marginBottom: '0' }}>
                <S.ButtonGroup gap={35} $justifyContentEnd={true}>
                    <S.Button variant={S.ButtonType.bordered} onClick={props.closeDeployDialog}>{FRENDS.Localizations.Cancel}</S.Button>
                    <S.ButtonGroup gap={10} $justifyContentEnd={true}>
                        <S.Button
                            id="deployDropDownButton"
                            disabled={props.deploymentDisabled}
                            onClick={handleDeployActivate}
                        >
                            {props.isSwitchVersion ? FRENDS.Localizations.SwitchActivate : FRENDS.Localizations.DeployActivate}
                        </S.Button>
                        <S.Button
                            id="processDeploymentRef"
                            disabled={props.deploymentDisabled}
                            onClick={handleDeployWithoutActivate}
                        >
                            {buttonLabel()}
                        </S.Button>
                    </S.ButtonGroup>
                </S.ButtonGroup>
            </S.FormGroup>
        );
    };

    return props.isSubprocessList ? getSubprocessDeploymentFooter() : getProcessDeploymentFooter();
};

interface DeployDialogFooterProps {
    deploymentDisabled: boolean;
    isSubprocessList: boolean;
    isSwitchVersion: boolean;
    deploymentDescription: string;
    closeDeployDialog: () => void;
    handleDeploy: (activate: boolean, deploymentDescription: string) => void;
}
